// (function () {
//   function initJudgmeTabs() {
//     const storeTab = document.getElementById('jdgm-tab_shop_reviews');
//     const productTab = document.getElementById('jdgm-tab_product_reviews');

//     if (!storeTab || !productTab) return false; // chưa có, thử lại

//     // 1. Đổi tên
//     storeTab.childNodes.forEach(node => {
//       if (node.nodeType === 3) { // text node
//         node.textContent = node.textContent.replace('Store reviews', 'All reviews');
//       }
//     });

//     // 2. Đưa lên trước
//     productTab.parentNode.insertBefore(storeTab, productTab);

//     // 3. Swap active
//     productTab.classList.remove('jdgm-tab--active');
//     productTab.setAttribute('aria-selected', 'false');
//     productTab.setAttribute('tabindex', '-1');

//     storeTab.classList.add('jdgm-tab--active');
//     storeTab.setAttribute('aria-selected', 'true');
//     storeTab.setAttribute('tabindex', '0');

//     // 4. Click để sync panel
//     storeTab.dispatchEvent(new MouseEvent('click', { bubbles: true }));

//     return true;
//   }

//   // Retry mỗi 300ms, tối đa 20 lần (6 giây)
//   let attempts = 0;
//   const timer = setInterval(function () {
//     attempts++;
//     const success = initJudgmeTabs();
//     if (success || attempts >= 20) {
//       clearInterval(timer);
//       if (!success) console.warn('[Judgme] Tab not found after 20 attempts');
//     }
//   }, 300);
// })();
// Thêm CSS
const style = document.createElement("style");
style.textContent = `
.jmm-verified-buyer-badge{
    display:inline-flex;
    align-items:center;
    justify-content:center;
    padding:3px 8px;
    border:1px solid #173057;
    border-radius:999px;
    // background:#f8f8f6;
    color:#2f4b7c;
    font-size:11px;
    font-weight:500;
    line-height:1.2;
    white-space:nowrap;
}

.jm-verified-buyer-badge__text{
    margin:0;
}
`;
document.head.appendChild(style);

function addVerifiedBadge() {
    document.querySelectorAll(".jm-reviewer-info").forEach(review => {
        if (review.querySelector(".jmm-verified-buyer-badge")) return;

        const nameRow = review.querySelector(".jm-reviewer-info__name")?.parentElement;
        if (!nameRow) return;

        const badge = document.createElement("div");
        badge.className = "jmm-verified-buyer-badge";
        badge.innerHTML = `<p class="jm-verified-buyer-badge__text">Verified</p>`;

        nameRow.appendChild(badge);
    });
}

addVerifiedBadge();

new MutationObserver(addVerifiedBadge).observe(document.body, {
    childList: true,
    subtree: true
});

